import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("sdi_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

client.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && !window.location.pathname.startsWith("/login")) {
      localStorage.removeItem("sdi_token");
      localStorage.removeItem("sdi_user");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  },
);

export function getErrorMessage(err) {
  const detail = err?.response?.data?.detail;
  if (Array.isArray(detail)) return detail.map((d) => d.msg).join(", ");
  if (typeof detail === "string") return detail;
  return "Something went wrong. Please try again.";
}

// For requests made with { responseType: "blob" } (document view/download) —
// axios still returns error bodies as a Blob, so the plain detail string
// needs to be read out of it first to show the real "file missing" message.
export async function getBlobErrorMessage(err) {
  const data = err?.response?.data;
  if (data instanceof Blob) {
    try {
      const parsed = JSON.parse(await data.text());
      if (typeof parsed.detail === "string") return parsed.detail;
    } catch {
      // fall through to generic message below
    }
  }
  return getErrorMessage(err);
}

export default client;
